import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { selectDataByKey } from 'src/storage/general.selectors';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { LoaderService } from '@app/services/general/loader.service';
import { LeadResumeSyncService } from '@app/services/lead-resume/lead-resume-store-sync.service';
import { DataLayerService } from '@app/services/dataLeyer/data-leyer.service';


@Component({
  selector: 'app-new-datos-inquilino-proceso',
  templateUrl: './new-datos-inquilino-proceso.component.html',
  styleUrl: './new-datos-inquilino-proceso.component.scss'
})

export class NewDatosInquilinoProcesoComponent implements OnInit, OnDestroy {
  loaderService = inject(LoaderService);
  private leadResumeSyncService = inject(LeadResumeSyncService);

  URLRetomaInquilino$: Observable<any>;
  private subscriptions: Subscription = new Subscription();
  link: string = '';
  isLoading: boolean = false;
  loaded: boolean = false;
  synced: boolean = false;
  private _dataLayerService = inject(DataLayerService);
  sessionId: string = '';

  constructor(private store: Store, private router: Router) {
    this.URLRetomaInquilino$ = this.store.select(selectDataByKey('URLRetomaInquilino'));
  }
  
  ngOnInit(): void {
    this.loaderService.show(); // Mostrar el loader al iniciar la carga de datos
    this.loaderService.loading$.subscribe(({ loading, loaded }: { loading: boolean; loaded: boolean }) => {
      this.isLoading = loading;
      this.loaded = loaded;
    });

    // 🔹 Lead Resume: Sincronizar TODOS los datos del Lead Resume con el store si existen
    // this.synced = this.leadResumeSyncService.syncAllLeadResumeData();

    this.sessionId = this.getLocalStorage().toString();
    
    this.subscriptions.add(
      this.URLRetomaInquilino$.subscribe(data => {
        console.log('URLRetomaInquilino:', data);
        this.link = data || "https://sura.co/inquilino/firmacontrato/";
      })
    );
    
    this._dataLayerService.logDataNewFlow(
      'Arriendo_ecommerce_step_5_Proceso_Inquilino',
      'Arriendo',
      'Proceso_Inquilino',
      'Pageview',
      this.sessionId
    )

    // Ocultar loader después de un breve delay para permitir que los datos se carguen
    setTimeout(() => this.loaderService.hide(), 500);
  }

  ngOnDestroy(): void {
    // Cleanup: desuscribirse de observables
    this.subscriptions.unsubscribe();
  }


  isModalVisible: boolean = false; // Controla la visibilidad del modal

  openModal(): void {
    this._dataLayerService.logDataNewFlow(
      'Arriendo_ecommerce_step_5_Proceso_Inquilino', 
      'Arriendo',
      'Proceso_Inquilino',
      'Button',
      this.sessionId
    )
    this.isModalVisible = true; // Muestra el modal
  }

  closeModal(): void {
    this.isModalVisible = false; // Cierra el modal
  }

  // Método para copiar el enlace al portapapeles
  copyLink(): void {
    navigator.clipboard.writeText(this.link).then(() => {
      console.log('Link copiado al portapapeles');
    }).catch(err => {
      console.error('Error al copiar el link: ', err);
    });
  }

  // Método para compartir en WhatsApp
  shareOnWhatsapp(): void {
    window.open(`https://wa.me/?text=${encodeURIComponent(this.link)}`, '_blank');
  }

  // Método para compartir en Mensajes
  shareMessage(): void {
    window.open(`sms:?body=${encodeURIComponent(this.link)}`, '_blank');
  }

  finish(){
    this._dataLayerService.logDataNewFlow(
      'Arriendo_ecommerce_step_5_Proceso_Inquilino', 
      'Arriendo',
      'Proceso_Inquilino',
      'Button',
      this.sessionId
    )
    window.location.href = 'https://www.sura.co/seguros/digitales';
  }

  getLocalStorage(): number {
    return Number(localStorage.getItem('session_id'));
  }
}